import "../styles/App.css"

function Footer() {
  return (
    <footer className="footer">
      <p>DogNutrition AI © {new Date().getFullYear()}</p>
      <p className="disclaimer">
        Disclaimer: Always consult with a veterinarian before making significant changes to your pet's diet.
      </p>
    </footer>
  )
}

export default Footer

